@import '../styles/fonts.scss';

.legend {
  @include barlow(14);
}
